module.exports = __webpack_public_path__ + "static/media/imgPreview.42af325.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AlertMPG/imgPreview.png
// module id = 1012
// module chunks = 0